import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance2,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  REPORTING_FUNDING,
  NOTIFICATION,
} from '../actionTypes';

const fetchFundingReporting = async (payload) => {
  const params = payload.payload;
  if (params?.query) {
    return axiosAuthInstance2.get(`${API_END_POINTS.REPORTING_FUNDINGS}${params.query}`);
  }
  return axiosAuthInstance2.get(`${API_END_POINTS.REPORTING_FUNDINGS}`);
};

export function* getFundingReporting(action) {
  try {
    const { data } = yield call(fetchFundingReporting, action.payload);
    yield put({ type: REPORTING_FUNDING.SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: REPORTING_FUNDING.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
